import { render, staticRenderFns } from "./Suc.vue?vue&type=template&id=08eb95f2&"
import script from "./Suc.vue?vue&type=script&lang=js&"
export * from "./Suc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports